<script setup>
import { BFormGroup } from 'bootstrap-vue-next';
import { computed } from 'vue';
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

const model = defineModel({ type: String });
const props = defineProps({
  aiSuggestion: {
    type: Object,
    required: false,
    default: null,
  },
  existingLabel: {
    type: String,
    required: false,
    default: '',
  },
  label: {
    type: String,
    required: true,
  },
  locked: {
    type: Boolean,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  aiError: {
    type: Boolean,
    required: true,
  },
});

const confidence = computed(() => {
  const confidenceValue = props.aiSuggestion.confidence;

  return confidenceValue >= 75 ? 'confidently' : 'tentatively';
});
</script>

<template>
  <BFormGroup
    :label="label"
    class="mb-3"
  >
    <VueSelect
      v-model="model"
      :options="options"
      placeholder="Select or type to search..."
      :disabled="locked"
    >
      <template #no-options="{ search, searching }">
        <span v-if="searching && search">
          No matching options for "{{ search }}"
        </span>
        <span v-else>
          No options available
        </span>
      </template>
    </VueSelect>
    <template #description>
      <template v-if="existingLabel" />
      <template v-else-if="aiError">GitLab Duo AI suggestions are temporarily unavailable</template>
      <template v-else-if="aiSuggestion == null">GitLab Duo AI is fetching suggestions...</template>
      <template v-else-if="aiSuggestion.deduced">
        GitLab Duo AI {{ confidence }} suggests
        <code v-if="locked">{{ aiSuggestion.deduced }}</code>
        <a
          v-else
          href="#"
          @click.prevent="model = aiSuggestion.deduced"
        >{{ aiSuggestion.deduced }}</a>
      </template>
      <template v-else>
        GitLab Duo AI has no suggestion for {{ label }}
      </template>
    </template>
  </BFormGroup>
</template>
